import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { NeonAuthUIProvider } from '@neondatabase/auth/react'
import { HelmetProvider } from 'react-helmet-async'
import '@neondatabase/auth/ui/css'
import App from './App'
import './index.css'
import { initSentry } from './lib/sentry'
import { ErrorBoundary } from './components/ui/ErrorBoundary'
import { authClient } from './lib/auth-client'

// F10: Initialize Sentry error tracking
initSentry()

// PI3: Remove loading class once app is ready
function AppWithLoadingRemoval() {
  useEffect(() => {
    // Remove loading class to show content with smooth transition
    const html = document.documentElement
    html.classList.remove('loading')
    html.classList.add('loaded')
  }, [])

  return <App />
}

// CRITICAL: Only run in browser, not during SSR/build
if (typeof window !== 'undefined') {
  const rootElement = document.getElementById('root')
  if (rootElement) {
    // Only use StrictMode in development to avoid production warnings
    const isDevelopment = import.meta.env.DEV

    if (isDevelopment) {
      createRoot(rootElement).render(
        <ErrorBoundary>
          <StrictMode>
            <HelmetProvider>
              <NeonAuthUIProvider authClient={authClient}>
                <AppWithLoadingRemoval />
              </NeonAuthUIProvider>
            </HelmetProvider>
          </StrictMode>
        </ErrorBoundary>
      )
    } else {
      createRoot(rootElement).render(
        <ErrorBoundary>
          <HelmetProvider>
            <NeonAuthUIProvider authClient={authClient}>
              <AppWithLoadingRemoval />
            </NeonAuthUIProvider>
          </HelmetProvider>
        </ErrorBoundary>
      )
    }
  }
}
